import React, { ReactNode } from 'react';

import './Steps.scss';

interface Props {
    children: ReactNode;
}

const Steps = (props: Props): JSX.Element => <div className="steps">{props.children}</div>;

export default Steps;
